/**
 * Hero chart block — interactions.
 */

const heroChartHandlers = () => {
	const promos = document.querySelectorAll( '.hero-chart-block .hc-promo' );
	if ( ! promos || promos.length === 0 ) return;

	promos.forEach( promo => {
		heroChartDisclaimerHandler( promo );
	} );
};

/**
 * Toggle the full disclaimer open/closed.
 */
const heroChartDisclaimerHandler = promo => {
	const triggers       = promo.querySelectorAll( '.disclaimer-toggle' );
	const fullDisclaimer = promo.querySelector( '.disclaimer-full' );
	if ( ! triggers.length || ! fullDisclaimer ) return;

	triggers.forEach( trigger => {
		trigger.addEventListener( 'click', e => {
			e.preventDefault();
			fullDisclaimer.classList.toggle( 'open' );
		} );
	} );
};

document.addEventListener( 'DOMContentLoaded', () => {
	heroChartHandlers();
} );
